var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckAppid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M12 2C6.47048 2 2 6.48922 2 12C2 17.5108 6.47048 22 12 22C17.5295 22 22 17.5295 22 12C22 6.47048 17.5201 2 12 2ZM11.194 16.4236L7.09841 12.2156L8.43861 10.9128L11.1659 13.7151L15.5052 8.27929L16.9672 9.4508L11.4189 16.4049C11.3627 16.4705 11.2596 16.4798 11.2034 16.4142L11.194 16.4236Z",
    fill: "#09B795"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAppid);
export default __webpack_public_path__ + "static/media/check_appid.f16c1e68c0ccc27990cb924840a87337.svg";
export { ForwardRef as ReactComponent };